export default __webpack_public_path__ + "static/media/img-2.ed908867.jpg";